import { render, staticRenderFns } from "./modelDiscussion.vue?vue&type=template&id=4c56d54c"
import script from "./modelDiscussion.vue?vue&type=script&lang=js"
export * from "./modelDiscussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c56d54c')) {
      api.createRecord('4c56d54c', component.options)
    } else {
      api.reload('4c56d54c', component.options)
    }
    module.hot.accept("./modelDiscussion.vue?vue&type=template&id=4c56d54c", function () {
      api.rerender('4c56d54c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/admin/discussion/modelDiscussion.vue"
export default component.exports